import request from '../common/request'; //获取token

export function GetToken(payload) {
  return request.get('/OAuth2/GetToken', payload);
} //获取用户所属单位编码

export function GetCode(payload) {
  return request.get('/sys/GetCode', payload);
} //用户身份绑定

export function BindUser(payload) {
  return request.post('/sys/BindUser', payload);
} //获取用户详细信息

export function GetUserByBarcode(payload) {
  return request.get('/user/GetUserByBarcode', payload);
} //更新用户信息

export function UpdateUserInfo(payload) {
  return request.get('/user/UpdateUserInfo', payload);
} //获取年级列表

export function GetGradeList(payload) {
  return request.post('/user/GetGradeList', payload);
} //获取班级列表

export function GetClassList(payload) {
  return request.post('/user/GetClassList', payload);
} //获取班级用户列表

export function GetClassUserList(payload) {
  return request.post('/user/GetClassUserList', payload);
} //获取授权码

export function GetDeviceCode(payload) {
  return request.post('/device/GetDeviceCode', payload);
} //获取授权应用列表

export function GetDeviceAppList(payload) {
  return request.get('/app/GetDeviceAppList', payload);
} //获取设备权限配置信息

export function GetDeviceSetting(payload) {
  return request.get('/device/GetDeviceSetting', payload);
} //获取jssdk配置信息

export function GetWxConfig(payload) {
  return request.get('/sys/GetWxConfig', payload);
} //上传

export function Upload(payload) {
  return request.post('/Upload/Posts', payload);
} //微信推送消息

export function SendMessage(payload) {
  return request.post('/wx/SendMessage', payload);
} //获取banner

export function GetBannerList(payload) {
  return request.post('/banner/GetBannerList', payload);
} //根据设备编码获取单位信息

export function GetCompanyByDevice(payload) {
  return request.post('/company/GetCompanyByDevice', payload);
} //解除身份绑定

export function UnbindUser(payload) {
  return request.post('/sys/UnbindUser', payload);
} //单人脸检测

export function Detect(payload) {
  return request.post('/face/Detect', payload);
} //人脸录入注册

export function UserAdd(payload) {
  return request.post('/face/UserAdd', payload);
} //获取中英文对照字典

export function GetTranslationDictionary(payload) {
  return request.get('/sys/GetTranslationDictionary', payload);
} //获取用户所在联盟列表

export function GetUnionUserCard(payload) {
  return request.post('/UnionSearch/GetUnionUserCard', payload);
} //获取用户人脸信息

export function GetUserFace(payload) {
  return request.post('/Face/GetUserFace', payload);
} //读者证挂失与解挂

export function UserRFIDManageMent(payload) {
  return request.post('/User/UserRFIDManageMent', payload);
} //新获取已授权应用列表

export function GetDeviceNewAppList(payload) {
  return request.post('/app/GetDeviceNewAppList', payload);
} //静默授权改为非静默更新用户信息

export function UpdateBindUserInfo(payload) {
  return request.post('/sys/UpdateBindUserInfo', payload);
} //校阅通嵌入登录

export function xytLogin(payload) {
  return request.post('/sys/xytLogin', payload);
} //用户查询

export function GetUserInfo(payload) {
  return request.post('/user/GetUserInfo', payload);
} //用户自定义编辑首页应用

export function CustomAppManagement(payload) {
  return request.post('/app/CustomAppManagement', payload);
} //用户获取自定义的首页应用

export function GetUserCustomAppList(payload) {
  return request.post('/app/GetUserCustomAppList', payload);
} //获取手机验证码

export function GetTLoginVeriCode(payload) {
  return request.post('/sys/GetTLoginVeriCode', payload);
} //校阅通手机号登录

export function XytSjhLogin(payload) {
  return request.post('sys/XytSjhLogin', payload);
} //单位信息登录获取验证码

export function GetComLoginVeriCode(payload) {
  return request.post('sys/GetComLoginVeriCode', payload);
} //应用点击记录

export function AppHits(payload) {
  return request.post('/Record/AppHits', payload);
} //黄浦区统一身份认证获取

export function GetHpeToken(payload) {
  return request.post('/Unified/GetHpeToken', payload);
} //用户代码查询

export function GetCustomerInfo(payload) {
  return request.post('/sys/GetCustomerInfo', payload);
} //单人脸检索

export function Search(payload) {
  return request.post('/face/Search', payload);
}